import React, { useState } from 'react'
import { MDBCol, MDBRow } from 'mdbreact';
import SubirImagenesContainer from '../../../SubirImagenes';
import { Image2, Search } from 'react-iconly';

const OpcionesImagen = (props) => {
    const { type, id, handleEstilosComponente, styles } = props;
    const [modal, setModal] = useState(false)
    const [urlImg, setUrlImg] = useState(styles?.urlImg)

    const modificarModal = () => {
        setModal(!modal)
    }

    const imagenActual = (img) => {
        handleEstilosComponente({ type, id, valor: img.path, nombre: 'urlImg' })
        setUrlImg(img.path)
        setModal(false)
    }
    return (
        <div><div className='mb-2'>
            <h4>Imagen</h4>
            <MDBRow className='mb-2'>
                <MDBCol>
                    <h6>Ancho</h6>
                    <input
                        defaultValue={styles?.widthImg}
                        type="number"
                        className="form-control form-control-sm"
                        onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'widthImg' })}
                    />
                </MDBCol>
                <MDBCol>
                    <h6>Alto</h6>
                    <input
                        defaultValue={styles?.heightImg}
                        type="number"
                        className="form-control form-control-sm"
                        onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'heightImg' })}
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className='mb-2'>
                <MDBCol>
                    <h6>Sombra</h6>
                    <input
                        defaultValue={styles?.shadowsImg}
                        type="number"
                        placeholder='1 a 5'
                        min={0}
                        max={5}
                        className="form-control form-control-sm"
                        onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'shadowsImg' })}
                    />
                </MDBCol>
                <MDBCol>
                    <div className='d-flex align-items-cente mb-2'>
                        <h6 className='m-0'>Url Imagen</h6>
                        <a onClick={modificarModal}>
                            <Image2 className="ml-1" set="bold" />
                        </a>
                    </div>
                    <input
                        defaultValue={urlImg}
                        type="text"
                        disabled
                        className="form-control form-control-sm"
                        onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'urlImg' })}
                    />
                </MDBCol>
            </MDBRow>
            <MDBRow className='mb-2'>

                <MDBCol>
                    <h6>Radio</h6>
                    <input
                        defaultValue={styles?.borderRadiusImagen}
                        type="number"
                        className="form-control form-control-sm"
                        onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'borderRadiusImagen' })}
                    />
                </MDBCol>
                <MDBCol>
                    <h6>Hipervinculo</h6>
                    <input
                        defaultValue={styles?.hipervinculo}
                        type="text"
                        className="form-control form-control-sm"
                        onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'hipervinculo' })}
                    />
                </MDBCol>
            </MDBRow>
        </div>
            <SubirImagenesContainer modal={modal} imagenActual={imagenActual} modificarModal={modificarModal} />
        </div>
    )
}

export default OpcionesImagen